import React, { useState } from 'react';
import './projects.css';
import image1 from "./images/sinsitria.png";
import image2 from "./images/yopex_logo (1).jpeg";
import image3 from "./images/khadamet.png";
import image4 from "./images/neotm.png"
import image5 from "./images/visiowaveNobg.png"
import image6 from "./images/rne.png"
import { Link } from 'react-router-dom';

const projects = [
  {
    id: 1,
    title: 'SinistrIA',
    description: 'B2B SaaS Platform for Insurance Claim Automation',
    image: image1,
    demoLink: "/SinistrIA",
    githubLink: 'https://github.com/OuhabYouceff/Boutelliss-SDL-2DGame',
  },
  {
    id: 2,
    title: 'Yopex',
    description: 'B2C Platform for Job Seekers and Employers',
    image: image2,
    demoLink:"/Yopex",
    githubLink: 'https://github.com/OuhabYouceff/RedRadio-Qt-App',
  },
  {
    id: 3,
    title: 'RNEBot',
    description: 'AI Chatbot for RNE reclamations',
    image: image6,
    demoLink: "/RNEBot",
    githubLink: 'https://github.com/OuhabYouceff/Calmini-PHP-App',
  },
  {
    id: 4,
    title: 'NeoTm',
    description: 'AI powered QA Platform for files comparison',
    image: image4,
    demoLink: "/NeoTm",
    githubLink: 'https://github.com/OuhabYouceff/Calmini-PHP-App',
  },
  {
    id: 5,
    title: 'Khadamet',
    description: 'Reclamation platform powered by AI',
    image: image3,
    demoLink: "/Khadamet",
    githubLink: 'https://github.com/OuhabYouceff/Calmini-PHP-App',
  },
  {
    id: 6,
    title: 'VisioWave',
    description: 'AI-Powered Image and Video Generation Platform',
    image: image5,
    demoLink: "/VisioWave",
    githubLink: 'https://github.com/OuhabYouceff/Calmini-PHP-App',
  }
  
  // Add more project objects as needed
];

const ProfessionalProjectList = () => {
  const [showAll, setShowAll] = useState(false);
  
  const initialProjects = projects.slice(0, 3);
  const additionalProjects = projects.slice(3);

  const displayedProjects = showAll ? projects : initialProjects;

  return (
    <section className="portfolio section" id='portfolio'>
    <div className="project-list" >
      <h2 className="section__title" >Professional Projects</h2>
      <span className="section__subtitle">Something to be proud of!</span>
      <div className="project-list__container ">
        {displayedProjects.map((project) => (
          <div className="project" key={project.id}>
            <div className="project__image">
              <img src={project.image} alt={project.title} />
            </div>
            <div className="project__content">
              <h3 className="project__title">{project.title}</h3>
              <p className="project__description">{project.description}</p>
              <div className="project__links">
                <Link to={project.demoLink} className='links__projects'>Details</Link>
                {/* <a href={project.githubLink} className='links__projects' target="_blank" rel="noopener noreferrer">GitHub</a> */}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {additionalProjects.length > 0 && (
        <div className="professional-projects__toggle">
          <button 
            className="button button--small professional-projects__button"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'Show Less' : 'Show More'}
          </button>
        </div>
      )}
    </div>
    </section>
  );
};

export default ProfessionalProjectList;
